import { formatDateTime } from '../utils/helpers';
import PropTypes from 'prop-types';

const Message = ({ text, userName, inputMethod }) => {
    return (
        <div className='lg:max-w-[full] sm:max-w-[full] py-2 mb-3 lg:mt-3'>
            <div className='grid mb-1' style={{direction: 'rtl'}}>
                <div className='flex justify-between w-[75%] lg:w-[60%]'>
                    <p className='text-[#404C5E] text-sm lg:text-base'>{formatDateTime()}</p>
                    <p className='font-medium text-sm lg:text-base'>{userName}</p>
                </div>
            </div>
            <div className='flex justify-end'>
                <div className='bg-[#0062ff] text-white p-3 border rounded-l-xl rounded-br-xl w-[75%] lg:w-[60%]' style={{textAlign: 'left'}}><h1>{text}</h1></div>
            </div>
        </div>
    );
};

Message.propTypes = {
    text: PropTypes.string.isRequired,
    userName: PropTypes.string,
    inputMethod: PropTypes.string
};

export default Message;